export default {
  message: {
    navigation:'返回首頁',
    heard:'等待付款',
    orderTitle:'訂單金額',
    exchangeRate :'固定匯率',
    PleaseOne: '請將',
    PleaseTwo: '幣發送到',
    PleaseThree: '網路上的该位址',
    Amount:'支付數量',
    wallerAddress:'錢包地址',
    error: '付款超時，訂單已關閉',
    errorTitle: '您的訂單已超時請重新發起！',
    succeed: '付款成功',
    succeedTitle: "您可在訂單清單中查看該訂單！",
    payNumber:'支付數量',
    repayNumber: '實際支付數量',
    orderAmount:'訂單金額',
    orderId:'訂單編號',
    meassage:"複製成功",
    Nodata:'無數據',
    OrderError:'訂單錯誤',
    verification:'order_id 驗證失敗,請聯絡商家處理',
  }, 
}